<components-loader *ngIf="loader"></components-loader>
<ng-container *ngIf="ready">
  <div class="container" [class.expanded]="menuExpanded" *ngIf="!noLayout">
    <app-side-bar (stateChanged)="menuStateChanged($event)" />
    <div id="main-container" class="content">
      <router-outlet />
    </div>
  </div>
  <div class="container" *ngIf="noLayout">
    <router-outlet />
  </div>
</ng-container>
<p-dialog
  *ngIf="dialog"
  [header]="dialog.header || ''"
  [modal]="true"
  [position]="dialog.position || 'center'"
  [closeOnEscape]="dialog.closeOnEscape || true"
  [closable]="true"
  [styleClass]="dialog.styleClass || ''"
  [showHeader]="true"
  [closeIcon]="' '"
  [visible]="dialog.visible"
  [draggable]="false"
>
  <div style="text-align: center">
    <span [innerHTML]="dialog.message"></span>
    <br />
    <br />
    <button
      label="Voltar"
      pButton
      pRipple
      class="mr-2"
      severity="danger"
      (click)="dialog.visible = false"
      *ngIf="!goBack"
    ></button>
    <button
      label="Voltar"
      pButton
      pRipple
      class="mr-2"
      severity="danger"
      (click)="goBackHistory()"
      *ngIf="goBack"
    ></button>
  </div>
</p-dialog>
<p-dialog
  [visible]="permissionDenied"
  [modal]="true"
  [position]="'center'"
  [closeOnEscape]="true"
  [closable]="false"
  [showHeader]="false"
  [closeIcon]="' '"
  [draggable]="false"
>
  <app-unauthorized
    [modal]="true"
    (navigate)="backFromPermission()"
    buttonLabel="Voltar"
  />
</p-dialog>
<p-dialog
  [visible]="sessionExpired"
  [modal]="true"
  [position]="'center'"
  [closeOnEscape]="true"
  [closable]="false"
  [showHeader]="false"
  [closeIcon]="' '"
  [style]="{ 'text-align': 'center' }"
  [draggable]="false"
>
  <p>Sessão expirada. Faça login novamente.</p>
  <br />
  <p-button (onClick)="login()" label="Ir para login" />
</p-dialog>
<p-dialog
  *ngIf="progress"
  [visible]="progressDialog"
  [modal]="true"
  position="center"
  [closeOnEscape]="false"
  [closable]="false"
  closeIcon=" "
  [style]="{ 'text-align': 'center' }"
  [draggable]="false"
  [header]="progressTitle"
>
  <div class="progress-bar">
    <p-progressBar [value]="progress"></p-progressBar>
  </div>
</p-dialog>
<p-toast />
